import axios from "axios";

export const getGroups = async ({ query = {}, controller = null, excludeInterceptor = false }: any) => {	
	const params: any = {params : query, excludeInterceptor}
	if(controller?.signal){
		params.signal = controller.signal
	}

	try {
		const res: any = await axios.get(`/clients/groups`, params);
		return res?.data ? res.data : [];
	} catch (e: any) {
		return [];
	}
};

export const getGroup = async ({ data, controller = null}: any) => {	
	try {
		const res: any = await axios.get(`/clients/groups/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const createGroup = async ({ data, create }: any) => {
	try {
		const res: any = await axios.post(`/clients/groups/`, create);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const updateGroup = async ({ data, update }: any) => {
	try {
		const res: any = await axios.put(`/clients/groups/${data.id}`, update);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};


export const deleteGroup = async ({ data }: any) => {
	try {
		const res: any = await axios.delete(`/clients/groups/${data.id}`);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};
